export const iconFontAwesomeMusicVideoMicrophoneLines = (
	<i className="fa-solid fa-microphone-lines"></i>
);
